
































import { Component, Vue, Watch, Emit } from 'vue-property-decorator';
import { getStatusByWorkflow } from '@/services/graph/workflow.graph';
import { namespace } from 'vuex-class';
import { FilterState } from '../../stores/modules/filter';

const product = namespace('product');
const filter = namespace('filter');

@Component({
  components: {}
})
export default class WorkflowFilter extends Vue {
  private status: any[] = [];
  private selectedStatus: any = [];

  @product.State(x => x.selected.workflow) workflow!: any;

  @filter.State(x => x.filter.workflowStatus) currentWorkflowStatus!: string[];
  @filter.Mutation('setFilterItem') setFilterItem!: (item: {
    key: keyof FilterState['filter'];
    val: any;
  }) => void;

  @Watch('currentWorkflowStatus')
  onStoreChange(val: string[], oldVal: string[]) {
    if (val.length !== oldVal.length) {
      this.selectedStatus = val;
    }
  }

  @Watch('workflow')
  onWorkflowChange(val: any) {
    this.getStatusse();
  }

  @Watch('selectedStatus')
  onSelect(statusse: string[]) {
    this.$emit('changed-status', statusse);
    this.setFilterItem({ key: 'workflowStatus', val: statusse });
  }

  getStatusse() {
    getStatusByWorkflow(this.workflow._id).then((data: any) => {
      this.status = data;
    });
  }
  mounted() {
    if (this.workflow && this.workflow._id) {
      this.getStatusse();
    }
  }
}
